import React from 'react';
import { Pagination as MuiPagination, Box, Typography, Select, MenuItem, FormControl } from '@mui/material';
import './Pagination.css';

const Pagination = ({
    currentPage,
    totalItems,
    itemsPerPage,
    onPageChange,
    onItemsPerPageChange,
    showItemsPerPage = true,
    itemsPerPageOptions = [10, 25, 50, 100]
}) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    if (totalItems === 0) {
        return null;
    }

    return (
        <Box className="pagination-container">
            <Box className="pagination-info">
                <Typography variant="body2" className="pagination-text">
                    Showing {startItem} to {endItem} of {totalItems} entries
                </Typography>
            </Box>

            <Box className="pagination-controls">
                {showItemsPerPage && (
                    <Box className="items-per-page">
                        <Typography variant="body2" className="pagination-label">
                            Show:
                        </Typography>
                        <FormControl size="small" className="items-per-page-select">
                            <Select
                                value={itemsPerPage}
                                onChange={(e) => onItemsPerPageChange(e.target.value)}
                                variant="outlined"
                            >
                                {itemsPerPageOptions.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                )}

                <MuiPagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, page) => onPageChange(page)}
                    color="primary"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    className="pagination-component"
                />
            </Box>
        </Box>
    );
};

export default Pagination;